import { vulnerabilityData } from "./vulnerabilityscan/scanData";
import { malwareData } from "./malware/scanData";

export const getVulnerabilityScanData = (scanId) => {
  const allScans = vulnerabilityData;

  const scan = allScans.find(scan => scan.scanId === scanId);

  if (!scan) {
    return { message: "Scan not found" };
  }

  if (scan.vulnerabilities) {
    return scan;
  } else if (scan.analysis) {
    return scan;
  }

  return { message: "Scan in progress" };
};

export const getMalwareScanData = (scanId) => {
  const allScans = malwareData;

  const scan = allScans.find(scan => scan.scanId === scanId);

  if (!scan) {
    return { message: "Scan not found" };
  }

  if (scan.analysisReport) {
    return scan;
  }

  return { message: "Scan in progress" };
};
